<template>
    <div v-if="group">
        <GroupViewAvatarCard/>
        <GroupViewGroupInfoCard />
        <GroupViewFiscalCard @refetch-data="fetchGroup"/>
        <GroupViewCashConfigCard />
    </div>
</template>

<script>
import { BRow, BCol, BAlert, BLink, BCard, BAvatar, BButton } from 'bootstrap-vue'
import { provide, ref, watch, inject  } from '@vue/composition-api'
import GroupViewCashConfigCard from './GroupViewCashConfigCard.vue'
import GroupViewGroupInfoCard from './GroupViewGroupInfoCard.vue'
import GroupViewFiscalCard from './GroupViewFiscalCard'
import GroupViewAvatarCard from './GroupViewAvatarCard'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import router from '@/router'
import axios from '@axios'

export default {
    components: { BRow, BCol, BAlert, BLink, BCard, BAvatar, BButton, GroupViewGroupInfoCard, GroupViewFiscalCard, GroupViewAvatarCard, GroupViewCashConfigCard },
    setup() {
        const { deletePopup } = popups()
        const group = ref(null)
        const selectedGroupId = inject('selectedGroupId')
        provide('group', group)

        //& Consultas
        const fetchGroup = () => {
            axios.get(`/groups/${selectedGroupId.value}`).then(response => {
                group.value = response.data.group
            })
        }

        fetchGroup()

        watch (selectedGroupId, () => {
            fetchGroup()
        }, {deep:true})
        

        return {
            group,
            ability,
            deletePopup,
            fetchGroup,
        }
    },
}
</script>

<style>

</style>